module.exports = __webpack_public_path__ + "static/media/mh_entrium_01.08f13863.png";